__webpack_require__.p = "https://smeconnect.vpbank.com.vn/giaingan/";